import { UploadError } from 'reactApp/modules/uploading/errors/UploadError';

export class InternalError extends UploadError {
    radarName = 'error_{SOURCE}_internal';
    message = 'Внутренняя ошибка сервера.';
}
